import { gql } from "@apollo/client";

export const getCardsQuery = gql`
query GetCardsandUsers($phone_number: String = "", $qr_code: String = "") {
  gogas_users(where: {phone_number: {_eq: $phone_number}}) {
    id
  }
  gogas_lpg_cards(where: {qr_code: {_eq: $qr_code}}) {
    extraa_user_id
    gogas_user_id
    id
    rfid
  }
  users(where: {phone_number: {_eq: $phone_number}}) {
    id
  }
  already_check: gogas_lpg_cards(where: {phone_number: {_eq: $phone_number}}) {
    extraa_user_id
    gogas_user_id
    id
  }
  gogas_new_registrations(where: {phone_number: {_eq: $phone_number}}) {
    id
  }
}
`